import React from 'react';
import { Routes, Route, Link } from 'react-router-dom';
import ScannerDiagnostic from '../components/ScannerDiagnostic';
import SimpleCameraTest from '../components/SimpleCameraTest';

const DiagnosticPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 py-8">
      <div className="max-w-6xl mx-auto px-4">
        <div className="mb-8">
          <Link 
            to="/check_in"
            className="text-blue-600 hover:text-blue-800 font-medium"
          >
            ← Back to Check In
          </Link>
        </div>
        
        <div className="space-y-8">
          <SimpleCameraTest />
          <ScannerDiagnostic />
        </div>
      </div>
    </div>
  );
};

export default DiagnosticPage;
